export const theme = {
  imagesize: {
    normal: {
      width: '1',
      height: '1',
    },
    wide: {
      width: '2',
      height: '1',
    },
    wider: {
      width: '3',
      height: '1',
    },
    high: {
      width: '1',
      height: '2',
    },
    higher: {
      width: '1',
      height: '3',
    },
    rectangle: {
      width: '2',
      height: '2',
    },
  },
  // notes: 'hsl(49, 100%, 58%, 80%)',
  // twitters: 'hsl(196, 83%, 75%)',
  // gold: 'hsl(40, 89%, 61%, 90%)',
  // notesHover: 'hsl(49, 100%, 58%, 85%)',
  // twittersHover: 'hsl(196, 83%, 80%)',
  // goldHover: 'hsl(40, 89%, 61%, 95%)',
  // notesClick: 'hsl(49, 100%, 58%, 90%)',
  // twittersClick: 'hsl(196, 83%, 85%)',
  // goldClick: 'hsl(40, 89%, 61%, 99%)',
  // articles: 'hsla(62, 78%, 66%, 90%)',
  // almostReady: '#f2cc8f',
  // readyToGo: 'hsl(151, 24%, 60%)',
  // ready: 'hsl(151, 24%, 60%)',
  // readyLight: 'hsl(151, 24%, 63%)',
  // readyHalfDark: 'hsl(151, 24%, 55%)',
  // readyDark: 'hsl(151, 24%, 50%)',
  // delivered: 'hsl(151, 24%, 30%)',
  // itemReady: 'hsl(151, 42%, 87%)',
  // notReady: 'hsl(13, 68%, 63%)',
  // notReadyLight: 'hsl(13, 68%, 66%)',
  // notReadyHalfDark: 'hsl(13, 68%, 58%)',
  // notReadyDark: 'hsl(13, 68%, 53%)',
  // white: 'hsl(106, 100%, 100%, 90%)',
  // cultured: 'hsl(160, 10%, 94%)',
  // product: 'hsla(32, 100%, 49%, 95%)',
  // background: 'hsl(208, 43%, 59%)',
  // opacityBackground: 'rgba(100, 100, 100, 0.2)',
  // grey100: 'hsl(0, 0%, 96%)',
  // grey100a: 'hsla(6, 0%, 96%, 50%)',
  // grey200: 'hsl(0, 0%, 92%)',
  // grey200a: 'hsla(0, 0%, 92%, 25%)',
  // grey300: 'hsl(0, 0%, 86%)',
  // grey300a: 'hsla(0, 0%, 86%, 15%)',
  // grey350: 'hsl(0, 0%, 80%)',
  // grey400: 'hsl(0, 0%, 70%)',
  // grey500: 'hsl(0, 0%, 60%)',
  // grey550: 'hsl(0, 0%, 50%)',
  // grey600: 'hsl(0, 0%, 25%)',
  // grey800: 'hsl(0, 0%, 20%)',
  // grey800a: 'hsla(0, 0%, 20%, 70%)',
  // black: 'hsl(0, 0%, 0%)',
  // fontSize: {
  //   xs: '10px',
  //   s: '12px',
  //   m: '16px',
  //   sl: '20px',
  //   l: '24px',
  //   xl: '32px',
  // },
  // leftSidebar: {
  //   width: '400px',
  //   height: '94vh',
  // },
  // rightSidebar: {
  //   width: '770px',
  //   height: '94vh',
  // },
  // btnSize: {
  //   small: '30px',
  //   medium: '60px',
  //   large: '72px',
  // },
  // fontWeight: {
  //   light: 200,
  //   bold: 600,
  // },
  // boxShadow: {
  //   btn: 'rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px',
  // },
}
